import styles from './styles.module.scss';
import { FaCheckCircle } from 'react-icons/fa';
import { AiFillCloseCircle } from 'react-icons/ai';

export const columns: any = [
  {
    field: 'last_name',
    headerName: 'Фамилия',
    width: '100%',
  },
  {
    field: 'first_name',
    headerName: 'Имя',
    width: '100%',
  },
  {
    field: 'patronymic',
    headerName: 'Отчество',
    width: '100%',
  },
  {
    field: 'policy_number',
    headerName: '№ полиса',
    width: '100%',
  },
  {
    field: 'gender',
    headerName: 'Пол',
    width: '100%',
  },
  {
    field: 'insurance_program',
    headerName: 'Программа покрытия',
    width: '200px',
  },
  {
    field: 'phone',
    headerName: 'Номер телефона',
    width: '120px',
  },
  {
    field: 'region',
    headerName: 'Регион',
    width: '180px',
  },
  {
    field: 'city',
    headerName: 'Город',
    width: '180px',
  },
  {
    field: 'district',
    headerName: 'Район',
    width: '200px',
  },
  {
    field: 'address',
    headerName: 'Улица',
    width: '200px',
  },
  {
    field: 'birth_date',
    headerName: 'Дата рождения',
    width: '130px',
  },
  {
    field: 'policy_start_date',
    headerName: 'Дата начало',
    width: '100px',
  },
  {
    field: 'policy_end_date',
    headerName: 'Дата окончания',
    width: '120px',
  },
  {
    field: 'status',
    headerName: 'Статус',
    position: 'sticky',
    width: '50px',
    renderCell: (data: any, ref: any) => {
      return data.status ? (
        data.status === 'active' ? (
          <AiFillCloseCircle className={styles.icon} color='red' />
        ) : (
          <FaCheckCircle className={styles.icon} color='green' />
        )
      ) : null;
    },
  },
];
